import { takeLeading } from 'redux-saga/effects'
import request from 'services/Request'
import * as actionTypes from '../actionTypes'
import * as api from '../api'
import prepareSearchArgs from '../searchStoreHelper'

export function* loadMoreResult(): Generator {
  const isLoadMore = true
  const args = yield prepareSearchArgs(isLoadMore)
  yield request(actionTypes.LOAD_MORE_RESULTS_REQUESTED, api.getStoreList, args)
}

export function* loadMoreSaga() {
  yield takeLeading(actionTypes.LOAD_MORE_RESULTS, loadMoreResult)
}

export default loadMoreSaga
